<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <div>
      <Trigger
        :project-uuid="data.projectUuid"
        :name="data.triggerName"
        :props="data.triggerProps"
        @update-name="data.triggerName = $event"
        @update-props="data.triggerProps = $event"
      />

      <Action
        v-if="data.triggerName && data.triggerProps"
        :project-uuid="data.projectUuid"
        :account-uuid="data.accountUuid"
        :name="data.actionName"
        :props="data.actionProps"
        class="mt-16"
        @update-name="data.actionName = $event"
        @update-props="data.actionProps = $event"
      />

      <form
        v-if="data.triggerName && data.triggerProps && data.actionName && data.actionProps"
        class="mt-16"
        @submit.prevent="handleSubmit(submitForm)"
      >
        <button class="btn btn-brand" :disabled="invalid">Submit</button>
      </form>
    </div>
  </ValidationObserver>
</template>

<script>
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';
import Trigger from './Trigger.vue';
import Action from './Action.vue';

const DEFAULT_AUTOMATION = {
  triggerName: null,
  triggerProps: null,
  actionName: null,
  actionProps: null,
  projectUuid: null,
};

export default {
  mixins: [veeValidateErrorsMixin],

  components: {
    Trigger,
    Action,
  },

  props: {
    automation: { type: Object, default: () => DEFAULT_AUTOMATION },
    submitAction: {
      type: Function,
      default: () => {
        throw new Error('missing submit-action');
      },
    },
  },

  data() {
    return {
      formScope: 'automations',
      data: {
        ...DEFAULT_AUTOMATION,
        ...this.automation,
      },
    };
  },

  methods: {
    async submitForm() {
      const submitWithErrorHandling = this.handleFormErrors(this.submitAction);

      this.submitting = true;

      await submitWithErrorHandling(this.data);

      this.submitting = false;
    },

    handleFormErrors(fn) {
      return (...params) =>
        fn(...params)
          .then(() => {
            this.$refs.modal.doClose();
          })
          .catch(({ status, data: { errors = {} } = {} } = {}) => {
            if (status && status === HTTP_UNPROCESSABLE_ENTITY) {
              this.observer = this.$refs.observer;
              this.addServerErrors(errors);
            }
          });
    },
  },
};
</script>
